import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import userActions from '../../user/userActions';
import policyActions from '../../policy/policyActions';

import CustomerList from './CustomerList';
import Page from '../../components/common/Page';
import { PageContent, PageHeader } from '../../components/common';
import Utils, { SecurityRoles, AdjudicationStatus, PolicyStatus } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	customers: UserDetails[];
	history?: any;
}
interface State {
	customers: UserDetails[];
	isLoading: boolean;
	searchterm: string;
	showComplete: boolean;
}

class CustomerListPage extends React.Component<Props, State> {
	handleSearchDebounced = Utils.debounce(() => this.search(this.state.searchterm), 200);

	constructor(props: Props) {
		super(props);
		this.state = {
			customers: [],
			isLoading: true,
			searchterm: '',
			showComplete: true
		};
	}

	componentDidMount() {
		this.props.actions
			.fetchCustomers()
			.then(() => this.setState({ customers: this.props.customers, isLoading: false }));
	}

	onSearch = (e: any) => {
		this.setState({ searchterm: e.target.value }, () => {
			this.handleSearchDebounced();
		});
	}
	search = (searchterm: string) => {
		const value = searchterm.toLowerCase();
		let customers = this.props.customers.filter(function (c: UserDetails) {
			let fullName = c.fullName || '';
			let email = c.email || '';
			return fullName.toLowerCase().startsWith(value) || email.toLowerCase().startsWith(value);
		});

		this.setState({ customers });
	}

	onClickComplete = () => {
		if (this.state.isLoading) {
			return;
		}
		if (!this.state.showComplete) {
			this.setState({ isLoading: true, showComplete: true });
			this.props.actions
				.fetchCustomers()
				.then(() => this.search(this.state.searchterm))
				.then(() => this.setState({ isLoading: false }));
		}
	}

	onClickProspects = () => {
		if (this.state.isLoading) {
			return;
		}
		if (this.state.showComplete) {
			this.setState({ isLoading: true, showComplete: false });
			this.props.actions
				.fetchCustomers(true)
				.then(() => this.search(this.state.searchterm))
				.then(() => this.setState({ isLoading: false }));
		}
	}

	sortByEffectiveDate = (policyA: CustomerPolicy, policyB: CustomerPolicy) => {
		return policyA.effectiveDate! > policyB.effectiveDate! ? 1 : -1;
	}

	generateCombinedStatus = (customer: UserDetails) => {
		if (customer.policies === undefined || customer.policies.length === 0 || customer.policies.some(p => p.isActive === true)) {
			return ''; // only customer who has no active policy will be displayed in applicant list
		}
		const sortedPolicies = customer.policies.sort(this.sortByEffectiveDate);
		let returnedStatus = '';
		let returnedCell;
		if (sortedPolicies && sortedPolicies.some(p => p.adjudicationStatusId !== undefined)) {
			const adjudicationPolicies = sortedPolicies.filter(p => p.adjudicationStatusId !== undefined);
			const declinedStatus = this.generateDeclinedStatus(adjudicationPolicies[0], returnedStatus);
			const adjudicationStatus = this.generateAdjudicationStatus(adjudicationPolicies[0], returnedStatus);
			returnedCell = (
				<div>{declinedStatus}<em>{adjudicationStatus}</em></div>
			);
		} else {
			const declinedStatus = this.generateDeclinedStatus(sortedPolicies[0], returnedStatus);
			returnedCell = (
				<div>
					{declinedStatus}
				</div>
			);
		}
		return returnedCell;
	}

	generateAdjudicationStatus = (policy: CustomerPolicy, statusText: string) => {
		switch (policy.adjudicationStatusId) {
			case AdjudicationStatus.Unreviewed:
				statusText += '(Unreviewed)';
				break;
			case AdjudicationStatus.InProcess:
				statusText += '(In Process)';
				break;
			case AdjudicationStatus.Rejected:
				statusText += '(Rejected)';
				break;
			default:
				break;
		}
		return statusText;
	}

	generateDeclinedStatus = (policy: CustomerPolicy, statusText: string) => {
		if (policy.isSoftDeclined || policy.isHardDeclined) {
			statusText += policy.isSoftDeclined ? 'Soft Declined' : 'Hard Declined';
			return statusText;
		} else {
			switch (policy.statusId) {
				case PolicyStatus.Inactive:
					statusText += 'Inactive';
					break;
				case PolicyStatus.Canceled:
					statusText += 'Canceled';
					break;
				default:
					break;
			}
			return statusText;
		}
	}

	shouldShowBoldRow = (customer: UserDetails) => {
		if (customer.policies && customer.policies.some(p => p.adjudicationStatusId !== undefined)) {
			return true;
		} else {
			return false;
		}
	}

	render() {
		return (
			<Page title="Customers">
				<PageContent>
					<PageHeader title="Customers" />
					<CustomerList
						customers={this.state.customers}
						history={this.props.history}
						isLoading={this.state.isLoading}
						searchterm={this.state.searchterm}
						onSearch={this.onSearch}
						onClickComplete={this.onClickComplete}
						onClickProspects={this.onClickProspects}
						showComplete={this.state.showComplete}
						setRedirectFromAdjudication={this.props.actions.setRedirectFromAdjudication}
						generateCombinedStatus={this.generateCombinedStatus}
						shouldShowBoldRow={this.shouldShowBoldRow}
					/>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		customers: state.user.customers
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...userActions, ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(CustomerListPage);
const adminRoles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, adminRoles);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerListPage.tsx